import React, { Component } from "react";
import URI from "urijs";
import ArtFilter from "./ArtFilter.jsx";
import ArtList from "./ArtList.jsx";

const parseLocation = (location) => {
    const params = URI.parseQuery(location);
    return params;
}

class ArtSearchComponent extends Component {
    constructor(props) {
        super(props);
        const confRoot = document.getElementById('artworkroot');
        this.url = confRoot.getAttribute("data-url");
        this.filterurl = confRoot.getAttribute("data-filters");
        this.navigate = this.navigate.bind(this);
        this.hashChange = this.hashChange.bind(this);
        const location = window.location.hash.replace(/^#\/?|\/$/g, '');
        this.state = {
            query: parseLocation(location)
        };
    }

    hashChange() {
        const location = window.location.hash.replace(/^#\/?|\/$/g, '');
        this.setState({
            query: parseLocation(location)
        });
    }

    componentDidMount() {
        window.addEventListener("hashchange", this.hashChange, false);
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.hashChange, false);
    }

    navigate(change) {
        const query = Object.assign(this.state.query, change);
        window.location.href =
            window.location.pathname + window.location.search + '#' + URI.buildQuery(query)
        ;
    }

    render() {
        const location = window.location.hash.replace(/^#\/?|\/$/g, '');
        return <div>
                    <div className="header section--white">
                        <div className="header_content">
                            <ArtFilter navigate={this.navigate} query={this.state.query} url={this.filterurl}/>
                        </div>
                    </div>
                    <ArtList query={this.state.query} querystring={location} url={this.url}/>
                </div>;
    }
}

export default ArtSearchComponent;
